import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {quotesKeyToArrayOfQuotes, quoteIdAttribute} from './relationships';

let quotes = {};
let general = {};

const defaults = {

};

const QuoteStore = createStore({
  idAttribute: quoteIdAttribute,
  storeEventBaseKey: "quotes",
  normalizr: quotesKeyToArrayOfQuotes,
  normalizrKey: "quotes",
  getData(){
    return quotes;
  },
  getDefaults(){
    return defaults;
  },
  getGeneral(){
    return general;
  }
});


window.QuoteStore = QuoteStore;
export default QuoteStore;





export const mockPayload = {
  quotes: [
    {
      quoteId: "1", 
      optionId: "1234",
      bolNumber: "6547",
      estimatedPickupDate: "12/24/2016",
      estimatedTransitTime: "2 Days",
      estimatedCost: 3145.50
    
    },
    {
      quoteId: "2", 
      optionId: "123",
      bolNumber: "654", 
      estimatedPickupDate: "12/24/2016",
      estimatedTransitTime: "3 Days",
      estimatedCost: 2045
    },
    {
      quoteId: "3",
      optionId: "1239",
      bolNumber: "6545",
      estimatedPickupDate: "12/24/2016",
      estimatedTransitTime: "4 Days",
      estimatedCost: 1005
    }
  ]
}


// WEBPACK FOOTER //
// ./src/stores/QuoteStore.js